import { render, staticRenderFns } from "./Resubmission.vue?vue&type=template&id=4942b490&scoped=true&"
import script from "./Resubmission.vue?vue&type=script&lang=js&"
export * from "./Resubmission.vue?vue&type=script&lang=js&"
import style0 from "./Resubmission.vue?vue&type=style&index=0&id=4942b490&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4942b490",
  null
  
)

export default component.exports